var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("app-dialer-main-popup", {
    attrs: {
      avatar: _vm.avatar,
      agent: _vm.agent,
      contact: _vm.contact,
      identifier: _vm.identifier,
      description: _vm.description,
      members: _vm.members,
      timestamp: _vm.timestamp,
      "session-id": _vm.sessionId,
      "is-connecting": _vm.isConnecting,
      "is-in-progress": _vm.isInProgress,
      "is-on-hold": _vm.isContactOnHold,
      "is-muted": _vm.isAgentMuted,
      "is-put-on-hold-action-loading": _vm.isPutOnHoldActionLoading,
      "is-hang-up-action-loading": _vm.isHangUpActionLoading,
      "is-info-active": _vm.isInfoActive,
      "is-keypad-active": _vm.isKeypadActive,
      "is-members-popup-active": _vm.isMembersPopupActive,
      "is-invite-popup-active": _vm.isInvitePopupActive,
      "is-transfer-popup-active": _vm.isTransferPopupActive,
      "has-keypad-button": _vm.hasKeypadButton,
      "has-invite-button": _vm.hasInviteButton,
      "has-transfer-button": _vm.hasTransferButton,
      "has-hold-button": _vm.hasHoldButton,
      "has-mute-button": _vm.hasMuteButton,
      "show-go-to-button": _vm.showGoToButton,
    },
    on: {
      "toggle-info": function ($event) {
        return _vm.$emit("toggle-info")
      },
      "toggle-members-popup": function ($event) {
        return _vm.$emit("toggle-members-popup")
      },
      "toggle-keypad": function ($event) {
        return _vm.$emit("toggle-keypad")
      },
      "toggle-invite-popup": function ($event) {
        return _vm.$emit("toggle-invite-popup")
      },
      "toggle-transfer-popup": function ($event) {
        return _vm.$emit("toggle-transfer-popup")
      },
      "put-on-hold": _vm.onTogglePutOnHold,
      "mute-self": _vm.onToggleMuteSelf,
      "hang-up": _vm.onHangUp,
      "go-to-session": _vm.onGoToSession,
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }